import { ApiRequest } from "../../Common";
import { User } from "..";
import { endpoints } from "../Constants/endpoints";

// eslint-disable-next-line consistent-return
export const getUserDetails = async () => {
  const response = await ApiRequest.fromPath(endpoints.users.myInfo())
    .withAuthHeader()
    .get();
  if (response.ok) {
    const userResponse = await response.json();
    return userResponse;
  }
  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }
};
